import { createContext, useEffect } from 'react';

interface SiftContextType {
  siftSessionId?: string;
}

interface SiftProviderProps {
  children: React.ReactNode;
  SIFT_BEACON_KEY?: string;
  siftSessionId?: string;
  accountId?: string;
}

const SiftContext = createContext<SiftContextType>({});

function addSiftScript() {
  const script = document.createElement('script');
  script.src = 'https://cdn.sift.com/s.js';
  document.body.appendChild(script);
}

function SiftProvider({
  children,
  SIFT_BEACON_KEY,
  siftSessionId,
  accountId,
}: SiftProviderProps) {
  useEffect(() => {
    if (siftSessionId || accountId) {
      const _sift = (window._sift = window._sift || []);
      _sift.push(['_setAccount', SIFT_BEACON_KEY]);
      _sift.push(['_setSessionId', siftSessionId]);
      _sift.push(['_setUserId', accountId]);
      _sift.push(['_trackPageview']);

      if (document.readyState === 'complete') {
        addSiftScript();
      } else {
        window.addEventListener('load', addSiftScript, false);
        return () => window.removeEventListener('load', addSiftScript, false);
      }
    }
  }, [accountId, SIFT_BEACON_KEY, siftSessionId]);

  return (
    <SiftContext.Provider value={{ siftSessionId }}>{children}</SiftContext.Provider>
  );
}

export { SiftContext, SiftProvider };
